import { Search } from "lucide-react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  onClear?: () => void;
  showClear?: boolean;
  placeholder?: string;
  className?: string;
}

/** Enter-to-search input with an optional Clear affordance, extracted from the
 * Employees list so every other feature's list page gets the same search
 * pattern for free instead of reimplementing it. */
export default function SearchInput({
  value,
  onChange,
  onSearch,
  onClear,
  showClear,
  placeholder = "Search…",
  className,
}: SearchInputProps) {
  return (
    <div className={`flex items-center gap-3 ${className ?? ""}`}>
      <div className="relative flex-1 max-w-md">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") onSearch(); }}
          placeholder={placeholder}
          className="w-full pl-10 pr-4 py-2.5 bg-surface-muted border border-transparent rounded-lg text-sm text-foreground placeholder-muted-foreground focus:outline-none focus:bg-surface focus:border-primary transition-colors"
        />
      </div>
      {showClear && (
        <button
          type="button"
          onClick={onClear}
          className="text-xs text-muted-foreground hover:text-foreground font-inter px-2 py-1 transition-colors"
        >
          Clear
        </button>
      )}
    </div>
  );
}
